'use client';

import { useWorldCupGameGroup } from '../hooks/use-world-cup-game-group';
import ListWithSkeleton from '../ui/ListWithSkeleton';
import { useMemo } from 'react';
import { WorldCupMatchCard } from './card';
import { toWorldCupMatchCardData } from './matchCardUtils';
import { useTranslation } from '@/lib/i18n';
import { isEmpty } from 'lodash';

export default function WorldCupMatchGroup({ eventSlug }: { eventSlug: string }) {
  const { t } = useTranslation();
  const { group, list, isLoading } = useWorldCupGameGroup({ eventSlug });
  const worldCupMatches = useMemo(() => list.map(toWorldCupMatchCardData), [list]);
  const groupName = group?.split(' ')?.[1];

  if (isEmpty(list)) {
    return null;
  }
  return (
    <section className="space-y-4">
      <div className="text-xl">
        {groupName ? t('Group {{group}} Games', { group: groupName }) : t('Games')}
      </div>
      <ListWithSkeleton
        loading={isLoading}
        list={worldCupMatches.length ? worldCupMatches : []}
        wrapperClassName="grid grid-cols-2 gap-3"
        itemRender={(item, index) => <WorldCupMatchCard key={item.slug || index} {...item} />}
      />
    </section>
  );
}
